<div class="modal-header">
    <h4 class="modal-title" id="mondalAddCampaignTitle">{{ isEdit? 'Editar' : 'Nueva ' }} campaña</h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<div class="modal-body">
    <h6>Ingresa la siguiente información:</h6>
    <form #f="ngForm">
        <div class="row">
            <div class="col mb-3">
                <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Nombre de campaña</mat-label>
                    <input  matInput placeholder="Ej: POP AGOSTO 2023" name="campaign" [(ngModel)]="newProject.name" required maxlength="45">
                    <mat-icon matSuffix>campaign</mat-icon>
                </mat-form-field>
            </div>
        </div>
        <div class="row g-2" *ngIf="!isEdit||(isEdit&&!isClientUsr)">
            <div class="col mb-0">
                <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Fecha de inicio de campaña</mat-label>
                    <input name="pickerInput" matInput [matDatepicker]="picker" [min]="minDate" placeholder="DD / MM / YYYY" disabled [(ngModel)]="date" required>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker disabled="false"></mat-datepicker>
                </mat-form-field>
            </div>
        </div>        

    </form>
</div>
<div class="modal-footer">
    <button mat-flat-button mat-dialog-close>Cerrar <mat-icon>close</mat-icon></button>
    <button mat-flat-button class="bg-success text-white" (click)="saveProject()">Guardar <mat-icon>save</mat-icon></button>
</div>